import { render, staticRenderFns } from "./CardAnchorList.vue?vue&type=template&id=4b6c3fff&scoped=true&"
import script from "./CardAnchorList.vue?vue&type=script&lang=js&"
export * from "./CardAnchorList.vue?vue&type=script&lang=js&"
import style0 from "./CardAnchorList.vue?vue&type=style&index=0&id=4b6c3fff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6c3fff",
  null
  
)

export default component.exports